/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse2009DataDocuments model module.
 * @module model/InlineResponse2009DataDocuments
 * @version 1.0.0
 */
class InlineResponse2009DataDocuments {
    /**
     * Constructs a new <code>InlineResponse2009DataDocuments</code>.
     * @alias module:model/InlineResponse2009DataDocuments
     */
    constructor() { 
        
        InlineResponse2009DataDocuments.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2009DataDocuments</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2009DataDocuments} obj Optional instance to populate.
     * @return {module:model/InlineResponse2009DataDocuments} The populated <code>InlineResponse2009DataDocuments</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2009DataDocuments();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Document ID
 * @member {Number} id
 */
InlineResponse2009DataDocuments.prototype['id'] = undefined;

/**
 * Document name
 * @member {String} name
 */
InlineResponse2009DataDocuments.prototype['name'] = undefined;






export default InlineResponse2009DataDocuments;

